import { render } from "./ConsultaPedidoModal.vue?vue&type=template&id=70199e48&scoped=true"
import script from "./ConsultaPedidoModal.vue?vue&type=script&lang=js"
export * from "./ConsultaPedidoModal.vue?vue&type=script&lang=js"

import "./ConsultaPedidoModal.vue?vue&type=style&index=0&id=70199e48&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70199e48"]])

export default __exports__